<template>
  <div class="wrapper d-flex align-center justify-center">
    <v-card class="login-card pa-6" elevation="6">
      <v-card-title class="justify-center mb-4">
        <img src="/img/logo-pontofiq-recorte.png" class="nao-autorizado-logo" alt="Logo" />
      </v-card-title>

      <div class="text-center">
        <h2 class="text-h5 font-weight-bold mb-2">Acesso Negado</h2>
        <p class="text-subtitle-1 mb-6">Você não tem permissão para acessar este recurso.</p>

        <v-btn color="primary" @click="$router.push({ name: 'home' })" rounded large>
          Voltar para o início
        </v-btn>
      </div>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "NaoAutorizado",
};
</script>

<style scoped>
.wrapper {
  height: 100vh;
  width: 100vw;
  background-image: url("../assets/background-2.png");
  background-size: cover;
  background-position: center;
}
.login-card {
  width: 90vw;
  max-width: 500px;
  background-color: rgba(255, 255, 255, 0.85);
  border-radius: 16px;
}
.nao-autorizado-logo {
  height: 110px;
  width: auto;
  object-fit: contain;
}
</style>
